import Variable from '../../constants/constants.json';

const { handleExcception } = require('../../api/sentryExceptionHandler');
const { GET_APPS } = require('../Constants/applications.constants');
const { createRequest } = require('../../api/client');

export const getAllApps = () => async (dispatch) => {
    const options = {
        url: `${Variable.backendUrl}/apps/getApps`,
        method: 'GET'
    };
    try {
        const data = await createRequest(options);
        dispatch({
            type: GET_APPS,
            data
        });
    } catch (err) {
        handleExcception(err);
    }
};

export const getAddApp = async (data) => {
    const options = {
        url: `${Variable.backendUrl}/apps/addAppToClient`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: data
    };
    try {
        await createRequest(options);
    } catch (err) {
        handleExcception(err);
    }
};

export const getRemoveApp = async (data) => {
    const options = {
        url: `${Variable.backendUrl}/apps/removeAppFromClient`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: data
    };
    try {
        await createRequest(options);
    } catch (err) {
        handleExcception(err);
    }
};
